// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-box[data-v-ceb9456c]{text-align:center;margin:60px 25px 25px 25px}.bottom-bar[data-v-ceb9456c]{background-color:#4abca5;border-top-style:solid;border-top-color:#837d89;border-top-width:5px}", ""]);
// Exports
module.exports = exports;
